const SPEECH_SYNTHESIS_LANGS = {
    english: 'en-IN',
    hindi: 'hi-IN',
    odia: 'or-IN',
    bengali: 'bn-IN',
    tamil: 'ta-IN',
    telugu: 'te-IN',
    kannada: 'kn-IN',
    malayalam: 'ml-IN',
    marathi: 'mr-IN',
    gujarati: 'gu-IN',
    punjabi: 'pa-IN',
    assamese: 'as-IN'
};

class TTS2AudioPlayer {
    constructor () {
        this._currentAudio = null;
        this._currentUtterance = null;
        this._finishCurrent = null;
    }

    playUrl (audioUrl) {
        this.stop();

        return new Promise((resolve, reject) => {
            const audio = new Audio(audioUrl);
            audio.preload = 'auto';
            this._finishCurrent = resolve;
            audio.onended = () => {
                this._finishCurrent = null;
                resolve();
            };
            audio.onerror = () => {
                this._finishCurrent = null;
                reject(new Error('Could not play generated speech audio.'));
            };
            this._currentAudio = audio;

            const playPromise = audio.play();
            if (playPromise && playPromise.catch) {
                playPromise.catch(error => {
                    this._finishCurrent = null;
                    reject(error);
                });
            }
        });
    }

    speakWithBrowser (text, language, speed) {
        this.stop();

        return new Promise(resolve => {
            if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
                resolve();
                return;
            }

            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = SPEECH_SYNTHESIS_LANGS[language] || 'en-IN';
            utterance.rate = Math.max(0.4, Math.min(1.6, Number(speed) || 1));
            this._finishCurrent = resolve;
            utterance.onend = () => {
                this._finishCurrent = null;
                resolve();
            };
            utterance.onerror = () => {
                this._finishCurrent = null;
                resolve();
            };

            this._currentUtterance = utterance;
            window.speechSynthesis.speak(utterance);
        });
    }

    stop () {
        if (this._currentAudio) {
            this._currentAudio.pause();
            this._currentAudio.currentTime = 0;
            this._currentAudio = null;
        }

        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
        }
        this._currentUtterance = null;

        if (this._finishCurrent) {
            const finish = this._finishCurrent;
            this._finishCurrent = null;
            finish();
        }
    }
}

export default TTS2AudioPlayer;
